"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var getDefaultContent = function getDefaultContent(property) {
  switch (property) {
    case 'type':
      return 'website';

    case 'title':
      {
        var _ref = document || {},
            title = _ref.title;

        return title;
      }

    case 'url':
      {
        var _ref2 = window.location || {},
            href = _ref2.href;

        return href;
      }

    default:
      break;
  }

  return null;
};

var OpenGraphMeta = function OpenGraphMeta(_ref3) {
  var passedProperty = _ref3.property,
      passedContent = _ref3.content;
  var property = "og:" + passedProperty;
  var content = passedContent || getDefaultContent(passedProperty);
  (0, _invariant.default)(!!content, "OpenGraphMeta: content required to render " + property + " meta tag");
  return _react.default.createElement("meta", {
    property: property,
    content: content
  });
};

OpenGraphMeta.propTypes = {
  content: _propTypes.default.string,
  property: _propTypes.default.oneOf(['description', 'image', 'title', 'type', 'url']).isRequired
};
var _default = OpenGraphMeta;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/components/elements/OpenGraphMeta.js
// module id = 275
// module chunks = 209 210 211 212